import * as actionTypes from './actionTypes';

export const initKryGrondvog = () => {
    return {
        type: actionTypes.INIT_GRONDVOG
    };
};

export const getGrondvog = (data) => {
    return {
        type: actionTypes.GET_PLAAS,
        data: data
    };
};

export const setGrondvog = (data) => {
    return {
        type: actionTypes.SET_GRONDVOG,
        data: data
    };
};

export const getGrondvogFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_GRONDVOG_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const toggleLayerSettingsDropdown = (key) => {
    return {
        type: actionTypes.LAYERSETTINGS_TOGGLE,
        key: key
    };
};

export const initKryLayerslys = () => {
    return {
        type: actionTypes.INIT_LAYERSLYS
    };
};

export const getLayerslys = (data) => {
    return {
        type: actionTypes.GET_LAYERSLYS,
        data: data
    };
};

export const setLayerslys = (data) => {
    return {
        type: actionTypes.SET_LAYERSLYS,
        data: data
    };
};

export const getLayerslysFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSLYS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};
export const kiesLayer = (key) => {
    return {
        type: actionTypes.KIES_LAYER,
        key: key
    };
};

export const initKryLayers = () => {
    return {
        type: actionTypes.INIT_LAYERSAKTIEF
    };
};

export const getLayers = (data) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF,
        data: data
    };
};

export const setLayers = (data) => {
    return {
        type: actionTypes.SET_LAYERSAKTIEF,
        data: data
    };
};

export const getLayersFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const removeLayer = (key) => {
    return {
        type: actionTypes.REMOVE_LAYER,
        key: key
    };
};

export const changeLayertipe = (key, tipe, layerkey) => {
    return {
        type: actionTypes.CHANGE_LAYERTIPE,
        key: key,
        tipe: tipe,
        layerkey: layerkey
    };
};

export const changeLayerFilter = (key, tipe, nuwewaarde) => {
    return {
        type: actionTypes.CHANGE_LAYERFILTER,
        key: key,
        tipe: tipe,
        nuwewaarde: nuwewaarde
    };
};

export const setLayerEventListener = () => {
    return (getState) => {
        console.log(getState());
        var data = [];
        const newlayersmetadata = [getState().layersmetadata.data];;
        for (var layer of newlayersmetadata) {
            for (var tipe of layer.layertipes) {
                if (tipe.active && tipe.infooverlay) {
                    if (getState().layers.data.find(obj => obj.id === layer.key)) {
                        data.push(getState().layer.data);
                    }
                }
            }
        }
        return {
            type: actionTypes.SET_LAYER_EVENTLISTENER,
            data: data
        };
    }

    // return {
    //     type: actionTypes.SET_LAYER_EVENTLISTENER,
    //     // key: key,
    //     // layerkey: layerkey
    // };
};

export const bindEventlistener = (mustbind) => {
    return {
        type: actionTypes.BIND_EVENTLISTENER,
        mustbind: mustbind
    };
};

export const bindComponent = () => {
    return {
        type: actionTypes.BIND_COMPONENT
    };
};